// React
import React, { useState, useRef } from "react";

// React Async
import Async from "react-async";

// Components
import { Form } from "react-bootstrap";
import {
  ProgressBar,
  Modal,
  Button,
  Table,
  Row,
  Col,
  Container,
  Badge
} from "react-bootstrap";
import {Alert} from "antd";
import LoaderButton from "../components/LoaderButton";
import ListSelectionTypeahead from "../components/ListSelectionTypeahead";

// Internal Libs
import { useFormFields } from "../libs/hooksLib";
import AffinityAPI from "../libs/AffinityAPI";
import * as EventifyAPI from "../libs/EventifyAPI";

// CSV
import parse from "csv-parse";

// Style
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

// Local Storage
import ls from "local-storage";

// AWS
import config from "../config";

// UUID
const uuidv4 = require("uuid/v4");

export default function InviteTeamMemberModal(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [invitedName, setInvitedName] = useState("");
  const [uploadButtonTitle, setUploadButtonTitle] = useState("Invite Team Member");

  const [fields, handleFieldChange] = useFormFields({
    name: "",
    email: ""
  });

  const nameRef = React.useRef();
  const emailRef = React.useRef();

  const options = ["Meme 1", "Meme 2", "Meme 3"];
  const multiple = true;

  function validateForm() {
    return true;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    EventifyAPI.createInvitedUser({
      name: fields.name,
      email: fields.email,
      organizationid: props.organizationid
    })
    .then((response) => {
      setInvitedName(response.name);
      setIsLoading(false);
    });
  }

  return (
    <Modal
      className="invite-team-member-modal"
      show={props.visible}
      onHide={props.onCancel}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Invite Team Member</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {invitedName &&
          <div className="alert">
            <Alert message={`${invitedName} has been invited!`} type="success" />
          </div>
        }
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="name">
            <Form.Label>Name</Form.Label>
            <Form.Control
              autoFocus
              type="text"
              autoComplete="off"
              value={fields.name}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              autoComplete="off"
              value={fields.email}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </Form>

      </Modal.Body>
      <Modal.Footer>
        <LoaderButton
          block
          type="submit"
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          {uploadButtonTitle}
        </LoaderButton>
      </Modal.Footer>
    </Modal>
  );
}
